/**
 * ticketTornPaper.ts — Tokens y geometría del borde rasgado en preview de tickets.
 *
 * QUÉ EXPORTA: colores, medidas y clip-path del ticket rasgado.
 * QUÉ NO DEBE HACER: Renderizar UI ni lógica de venta.
 */

/** Lienzo alrededor del ticket — blanco suave (menos brillante que el papel). */
export const TICKET_TORN_SURFACE = "#f6f6f6";

/** Clase del lienzo claro detrás del ticket en preview (web + térmica). */
export const TICKET_PREVIEW_CANVAS_CLASS = "ticket-preview-canvas";

/** Padding del lienzo del modal (alrededor del ticket; no modifica el papel). */
export const TICKET_PREVIEW_MODAL_CANVAS_PADDING_CLASS =
  "px-2 py-2 sm:px-2.5 sm:py-2";

/** Alineación dentro del modal: centrado horizontal, pegado arriba. */
export const TICKET_PREVIEW_MODAL_FRAME_CLASS =
  "flex w-full min-w-0 items-start justify-center";

/** Área scrolleable del modal con lienzo suave (cierre, venta, movimiento, pedido, credito). */
export const TICKET_PREVIEW_SURFACE_CLASS = `ticket-print-surface force-light flex-1 min-h-0 overflow-y-auto print:max-h-none print:p-0 print:overflow-visible ${TICKET_PREVIEW_CANVAS_CLASS} ${TICKET_PREVIEW_MODAL_CANVAS_PADDING_CLASS}`;

/** Mismo blanco que el cuerpo del ticket. */
export const TICKET_TORN_PAPER = "#ffffff";

/** Profundidad de cada diente (px). */
export const TICKET_TORN_DEPTH_PX = 8;

/** Dientes anchos con punta afilada (estilo Nequi). */
export const TICKET_TORN_TEETH_COUNT = 14;

/** clip-path del cuerpo: un solo bloque blanco sin línea de unión. */
export function buildTicketTornClipPath(
  teeth: number = TICKET_TORN_TEETH_COUNT,
  depthPx: number = TICKET_TORN_DEPTH_PX,
): string {
  const step = 100 / teeth;
  const d = `${depthPx}px`;
  const bottom = `calc(100% - ${depthPx}px)`;
  const pts: string[] = [`0 ${d}`];

  for (let i = 0; i < teeth; i += 1) {
    const xPeak = `${(i + 0.5) * step}%`;
    const xValley = `${(i + 1) * step}%`;
    pts.push(`${xPeak} 0`, `${xValley} ${d}`);
  }

  pts.push(`100% ${d}`, `100% ${bottom}`);

  // Puntas blancas hacia abajo (sin línea horizontal simulando un cuadrado).
  for (let i = teeth - 1; i >= 0; i -= 1) {
    const xPeak = `${(i + 0.5) * step}%`;
    const xValley = `${i * step}%`;
    pts.push(`${xPeak} 100%`, `${xValley} ${bottom}`);
  }

  pts.push(`0 ${bottom}`);
  return `polygon(${pts.join(", ")})`;
}

export const TICKET_TORN_CLIP_PATH = buildTicketTornClipPath();
